<template>
  <v-menu
    v-model="navigation.CRMWhatsappContactContextMenuIsVisible"
    @update:model-value="navigation.CRMWhatsappContactContextMenuIsVisible == false ? navigation.CRMWhatsappContactContextMenuItem = null : null"
    @contextmenu.prevent="navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;"
    :scrim="true"
    :activator="false"
    :close-on-content-click="false"
    location-strategy="static"
    style="user-select: none; cursor: default;"
  >
    <v-list 
      density="compact"
      style="position: absolute; width: 450px; height: 180px; max-height: 250px; overflow-y: auto; overflow-x: hidden;" 
      :style="`top: ${navigation.CRMWhatsappContactContextMenuY}px; left: ${navigation.CRMWhatsappContactContextMenuX}px;`"
    >
      <v-list-item 
        @click="$generalFunctions.default.copyToClipboard(this, 'ID del contacto', 'o', navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
        title="Copiar ID del contacto" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-barcode</v-icon>
          <v-icon color="indigo" size="x-small">mdi-paperclip</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="copyCRMWhatsappContactToClipboard(); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
        title="Copiar resumen del contacto" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-account</v-icon>
          <v-icon color="indigo" size="x-small">mdi-paperclip</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="$root.dialogComponent.openSendCRMWhatsappMessageToCRMWhatsappContactDialog(navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
        title="Iniciar conversación con el contacto" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-chat-plus</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="$root.dialogComponent.openCRMWhatsappConversationHistoryDialog(navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
        title="Ver historial de conversaciones del contacto" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-history</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="$root.dialogComponent.openCRMWhatsappContactLocationDialog(navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
        title="Ver ubicaciones del contacto" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-map-marker</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="$root.dialogComponent.openCRMWhatsappContactDialog(navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID, 'update'); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
        title="Actualizar contacto" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-pencil</v-icon>
        </template>
      </v-list-item>
      
      <template v-if="systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappContacts/deleteCRMWhatsappContact')?.CRMAgentPermissionValue == '1'">
        <v-list-item 
          @click="$root.dialogComponent.openCRMWhatsappContactDialog(navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID, 'delete'); navigation.CRMWhatsappContactContextMenuIsVisible = false; navigation.CRMWhatsappContactContextMenuItem = null;" 
          title="Eliminar contacto" 
          class="hoverableText" 
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-delete</v-icon>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
  
  <div class="mainContainer" @contextmenu.prevent="null" style="user-select: none; cursor: default;">
    <v-card v-if="navigation.searchVisible" :border="$vuetify.display.sm || $vuetify.display.xs ? null : 'e'" elevation="0" rounded="0" color="border" class="navigationContainer"> 
      <v-card elevation="0" rounded="0" color="primary" style="width: 100%; padding: 15px; display: flex; align-items: center;">
        <v-icon size="large" color="indigo">mdi-account</v-icon>
        <v-icon color="indigo" style="margin-right: 10px;">mdi-view-list</v-icon>
        <h4>LISTA DE CONTACTOS</h4>
        <div style="margin-left: auto; display: flex; gap: 5px;">
          <v-icon 
            @click="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)" 
            :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView" 
            size="x-small" 
            class="hoverableElement"
          >
            mdi-magnify
          </v-icon>
          <v-icon 
            @click="setDefaultValues()" 
            :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView" 
            size="x-small" 
            class="hoverableElement"
          >
            mdi-backspace
          </v-icon>
          <v-icon 
            @click="$generalFunctions.default.copyToClipboard(this, 'Búsqueda de contactos', 'a', null)" 
            :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView" 
            size="x-small" 
            class="hoverableElement"
          >
            mdi-share-variant
          </v-icon>
          <template v-if="navigation.searchVisible == true && display.CRMWhatsappContact.length > 0">
            <v-icon 
              @click="navigation.searchVisible = false" 
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView" 
              size="x-small" 
              class="hoverableElement hideSearchContainer"
            >
              mdi-arrow-left-bottom-bold
            </v-icon>
          </template>
        </div>
      </v-card> 
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <div class="navigationSearchContainer">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros del contacto:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-text-field 
              v-bind="props"
              ref="CRMWhatsappContactID"
              v-model="input.CRMWhatsappContactID"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-barcode"
              type="number"
              label="Filtrar por identificador interno"
              placeholder="Todos los identificadores internos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              hide-spin-buttons
              style="margin-bottom: 15px;"
            ></v-text-field>
          </template>
          <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática al contacto. Si se coloca un identificador interno, se buscará el único contacto que coincida con el mismo, ignorando el resto de filtros seleccionados</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappContactIDSearch"
              v-model="input.CRMWhatsappContactIDSearch"
              v-model:search="input.CRMWhatsappContactIDSearchAutocomplete"
              @input="autocompleteCRMWhatsappContact()"
              :items="display.CRMWhatsappContactOptions"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView || loader.autocompleteCRMWhatsappContact"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              @update:model-value="updateURLSearchQuery()"
              item-title="CRMWhatsappContactAutocomplete"
              item-value="CRMWhatsappContactID"
              prepend-inner-icon="mdi-account"
              label="Filtrar por contacto"
              placeholder="Todos los contactos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappContactIDSearch == item.raw.CRMWhatsappContactID"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappContactIDSearch == item.raw.CRMWhatsappContactID"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <div>
                      <p>{{ item.raw.CRMWhatsappContactName }}</p>
                      <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.raw.CRMWhatsappContactPhoneNumber, false) }}</p>
                    </div>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">Si se coloca un contacto, se buscará el único contacto que coincida con el mismo.</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMLocalityID"
              v-model="input.CRMLocalityID"
              :items="systemInformationData.CRMLocalities"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="input.allCRMLocalityIDSelected = input.CRMLocalityID.length == systemInformationData.CRMLocalities.length; input.CRMLocalityMapDivisionID.length = 0; input.allCRMLocalityMapDivisionIDSelected = false; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              item-title="CRMLocalityName"
              item-value="CRMLocalityID"
              prepend-inner-icon="mdi-store"
              label="Filtrar por localidad"
              placeholder="Todas las localidades"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMLocalityIDSelected" 
                  @update:model-value="input.CRMLocalityID = input.allCRMLocalityIDSelected ? systemInformationData.CRMLocalities.map(CRMLocality => CRMLocality.CRMLocalityID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMLocalityID.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMLocalityID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip :color="item.raw.CRMLocalityColor" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                      <p>{{ item.raw.CRMLocalityName }}</p>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor : 'primary'" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMLocalityID = input.CRMLocalityID.filter(CRMLocalityID => CRMLocalityID != item.value); input.allCRMLocalityIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityID.length - 3 }} localidad{{ input.CRMLocalityID.length - 3 == 1 ? '' : 'es' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La localidad a la que pertenece la orden. Si se coloca al menos una localidad, se buscarán todas las ordenes que pertenezcan a la localidad o localidades seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las localidades disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-textarea 
              v-bind="props"
              ref="CRMWhatsappContactNote"
              v-model="input.CRMWhatsappContactNote"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="updateURLSearchQuery()"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-note"
              label="Filtrar por nota"
              placeholder="Todas las notas"
              rows="2"
              max-rows="5"
              auto-grow
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              style="margin-bottom: 30px;"
            ></v-textarea>
          </template>
          <span style="max-width: 400px; display: block;">La nota de la orden. Si se coloca una nota, se buscarán todos los contactos que tengan al menos una nota que coincida total o parcialmente con la nota colocada</span>
        </v-tooltip>
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros de la conversación:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-text-field 
              v-bind="props"
              ref="CRMWhatsappConversationID"
              v-model="input.CRMWhatsappConversationID"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-barcode"
              type="number"
              label="Filtrar por identificador interno"
              placeholder="Todos los identificadores internos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              hide-spin-buttons
              style="margin-bottom: 15px;"
            ></v-text-field>
          </template>
          <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática a la conversación. Si se coloca un identificador interno, se buscará el contacto asignado a la conversación con dicho identificador, ignorando el resto de filtros seleccionados</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-select 
              v-bind="props"
              ref="lastCRMWhatsappConversationTime"
              v-model="input.lastCRMWhatsappConversationTime"
              :items="display.lastCRMWhatsappConversationTimeOptions"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="updateURLSearchQuery()"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-timer"
              label="Filtrar por tiempo desde última conversación" 
              placeholder="Todos los tiempos desde última conversación"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.lastCRMWhatsappConversationTime == item.value"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.lastCRMWhatsappConversationTime == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
            </v-select>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por tiempo desde última conversación permite buscar todos los contactos que no tengan ninguna conversación iniciada en un período de tiempo específico</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-textarea 
              v-bind="props"
              ref="CRMWhatsappConversationNote"
              v-model="input.CRMWhatsappConversationNote"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="updateURLSearchQuery()"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-note"
              label="Filtrar por nota de la conversación o de mensaje"
              placeholder="Todas las notas de la conversación o de mensaje"
              rows="2"
              max-rows="5"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              auto-grow
              hide-details
              style="margin-bottom: 15px;"
            ></v-textarea>
          </template>
          <span style="max-width: 400px; display: block;">La nota de la conversación o nota del mensaje. Si se coloca una nota, se buscarán todos los contactos que tengan al menos una una conversación o mensaje con una nota que coincida con la nota colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-textarea 
              v-bind="props"
              ref="CRMWhatsappMessageContent"
              v-model="input.CRMWhatsappMessageContent"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="updateURLSearchQuery()"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-message"
              label="Filtrar por contenido del mensaje"
              placeholder="Todos los contenidos del mensaje"
              rows="2"
              max-rows="5"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              auto-grow
              hide-details
              style="margin-bottom: 30px;"
            ></v-textarea>
          </template>
          <span style="max-width: 400px; display: block;">El contenido de un mensaje que forma parte de la conversación. Si se coloca un contenido del mensaje, se buscarán todos los contactos que tengan al menos un mensaje con un contenido que coincida total o parcialmente con el contenido del mensaje colocado</span>
        </v-tooltip>
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros de la orden:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-text-field 
              v-bind="props"
              ref="CRMWhatsappInvoiceID"
              v-model="input.CRMWhatsappInvoiceID"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-barcode"
              type="number"
              label="Filtrar por identificador interno"
              placeholder="Todos los identificadores internos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              hide-spin-buttons
              style="margin-bottom: 15px;"
            ></v-text-field>
          </template>
          <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática a la conversación. Si se coloca un identificador interno, se buscará el contacto asignado a la conversación con dicho identificador, ignorando el resto de filtros seleccionados</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-select 
              v-bind="props"
              ref="lastCRMWhatsappInvoiceTime"
              v-model="input.lastCRMWhatsappInvoiceTime"
              :items="display.lastCRMWhatsappInvoiceTimeOptions"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="updateURLSearchQuery()"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-timer"
              label="Filtrar por tiempo desde última orden" 
              placeholder="Todos los tiempos desde última orden"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.lastCRMWhatsappInvoiceTime == item.value"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.lastCRMWhatsappInvoiceTime == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
            </v-select>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por tiempo desde última orden permite buscar todos los contactos que no tengan ninguna orden generada en un período de tiempo específico</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMLocalityMapDivisionID"
              v-model="input.CRMLocalityMapDivisionID"
              :items="computed_CRMLocalityMapDivision"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
              @update:model-value="input.allCRMLocalityMapDivisionIDSelected = input.CRMLocalityMapDivisionID.length == display.CRMLocalityMapDivision.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-map-marker"
              item-title="CRMLocalityMapDivisionName"
              item-value="CRMLocalityMapDivisionID"
              label="Filtrar por zona geográfica"
              placeholder="Todas las zonas geográficas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 30px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMLocalityMapDivisionIDSelected" 
                  @update:model-value="input.CRMLocalityMapDivisionID = input.allCRMLocalityMapDivisionIDSelected ? display.CRMLocalityMapDivision.map(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMLocalityMapDivisionID.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMLocalityMapDivisionID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityColor : 'primary'" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                      <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityName : 'No registrada' }}</p>
                      <div style="display: flex; align-items: center;">
                        <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                        <p style="font-size: x-small;">{{ item.raw.CRMLocalityMapDivisionName }}</p>
                      </div>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip 
                  v-if="index < 3" 
                  :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityColor : 'primary'" 
                  variant="flat" 
                  elevation="2"
                  label
                >
                  <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityName : 'No registrada' }}</p>
                  <div style="display: flex; align-items: center;">
                    <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                    <p style="font-size: x-small;">{{ item.raw.CRMLocalityMapDivisionName }}</p>
                  </div>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMLocalityMapDivisionID = input.CRMLocalityMapDivisionID.filter(CRMLocalityMapDivisionID => CRMLocalityMapDivisionID != item.value); input.allCRMLocalityMapDivisionIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityMapDivisionID.length - 3 }} {{ input.CRMLocalityMapDivisionID.length - 3 == 1 ? 'división' : 'divisiones' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La zona geográfica de entrega de la orden. Si se coloca al menos una zona geográfica, se buscarán todas las ordenes entregadas en la zona o zonas geográficas seleccionadas. Al presionar el ícono de la derecha se seleccionan todas zonas geográficas disponibles</span>
        </v-tooltip>
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros por producto:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productID"
              v-model="input.productID"
              v-model:search="input.productIDSearch"
              :items="display.product"
              @keydown.enter.prevent="scanProduct()"
              @update:model-value="updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-package"
              label="Filtrar por producto"
              placeholder="Todos los productos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productID"
              item-title="productAutocomplete"
              clearable
              hide-no-data
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:chip="{ item }">
                <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.raw.productName}}</p>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productID == item.value"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productID == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <div>
                      <p>{{ item.raw.productName }}</p>
                      <p style="font-size: x-small; color: #9e9e9e;"><strong>{{ item.raw.productID }}</strong></p>
                    </div>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">Si se coloca un producto, se buscarán todas las ordenes que incluyan el producto seleccionado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productCategoryID"
              v-model="input.productCategoryID"
              :items="display.productCategory"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductCategoryIDSelected = input.productCategoryID.length == display.productCategory.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-cog"
              label="Filtrar por categoría"
              placeholder="Todas las categorías"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productCategoryID"
              item-title="productCategoryName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductCategoryIDSelected"
                  @update:model-value="input.productCategoryID = input.allProductCategoryIDSelected ? display.productCategory.map(productCategory => productCategory.productCategoryID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productCategoryID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productCategoryID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productCategoryID = input.productCategoryID.filter(productCategoryID => productCategoryID != item.value); input.allProductCategoryIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productCategoryID.length - 3 }} {{ input.productCategoryID.length - 3 == 1 ? 'categoría de producto' : 'categorías de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La categoría del producto. Si se coloca al menos una categoría de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las categorías de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las categorías de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productBrandID"
              v-model="input.productBrandID"
              :items="display.productBrand"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductBrandIDSelected = input.productBrandID.length == display.productBrand.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-archive"
              label="Filtrar por marca"
              placeholder="Todas las marcas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productBrandID"
              item-title="productBrandName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductBrandIDSelected" 
                  @update:model-value="input.productBrandID = input.allProductBrandIDSelected ? display.productBrand.map(productBrand => productBrand.productBrandID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productBrandID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productBrandID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productBrandID = input.productBrandID.filter(productBrandID => productBrandID != item.value); input.allProductBrandIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productBrandID.length - 3 }} {{ input.productBrandID.length - 3 == 1 ? 'marca de producto' : 'marcas de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La marca del producto. Si se coloca al menos una marca de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las marcas de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las marcas de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productModelID"
              v-model="input.productModelID"
              :items="display.productModel"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductModelIDSelected = input.productModelID.length == display.productModel.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-checkbox-blank"
              label="Filtrar por modelo"
              placeholder="Todas los modelos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productModelID"
              item-title="productModelName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductModelIDSelected" 
                  @update:model-value="input.productModelID = input.allProductModelIDSelected ? display.productModel.map(productModel => productModel.productModelID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productModelID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productModelID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productModelID = input.productModelID.filter(productModelID => productModelID != item.value); input.allProductModelIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productModelID.length - 3 }} {{ input.productModelID.length - 3 == 1 ? 'modelo de producto' : 'modelos de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La modelo del producto. Si se coloca al menos una modelo de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las modelos de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las modelos de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productFlavorID"
              v-model="input.productFlavorID"
              :items="display.productFlavor"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductFlavorIDSelected = input.productFlavorID.length == display.productFlavor.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-water"
              label="Filtrar por sabor"
              placeholder="Todos los sabores"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productFlavorID"
              item-title="productFlavorName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductFlavorIDSelected" 
                  @update:model-value="input.productFlavorID = input.allProductFlavorIDSelected ? display.productFlavor.map(productFlavor => productFlavor.productFlavorID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productFlavorID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productFlavorID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productFlavorID = input.productFlavorID.filter(productFlavorID => productFlavorID != item.value); input.allProductFlavorIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productFlavorID.length - 3 }} {{ input.productFlavorID.length - 3 == 1 ? 'sabor de producto' : 'sabores de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El sabor del producto. Si se coloca al menos una sabor de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los sabores de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los sabores de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productNicotineLevelID"
              v-model="input.productNicotineLevelID"
              :items="display.productNicotineLevel"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductNicotineLevelIDSelected = input.productNicotineLevelID.length == display.productNicotineLevel.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-cloud"
              label="Filtrar por nivel de nicotina"
              placeholder="Todos los niveles de nicotina"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productNicotineLevelID"
              item-title="productNicotineLevelName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductNicotineLevelIDSelected" 
                  @update:model-value="input.productNicotineLevelID = input.allProductNicotineLevelIDSelected ? display.productNicotineLevel.map(productNicotineLevel => productNicotineLevel.productNicotineLevelID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productNicotineLevelID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productNicotineLevelID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productNicotineLevelID = input.productNicotineLevelID.filter(productNicotineLevelID => productNicotineLevelID != item.value); input.allProductNicotineLevelIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productNicotineLevelID.length - 3 }} {{ input.productNicotineLevelID.length - 3 == 1 ? 'nivel de nicotina de producto' : 'niveles de nicotina de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El nivel de nicotina del producto. Si se coloca al menos una nivel de nicotina de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los niveles de nicotina de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los niveles de nicotina de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productSizeID"
              v-model="input.productSizeID"
              :items="display.productSize"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductSizeIDSelected = input.productSizeID.length == display.productSize.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-signal"
              label="Filtrar por tamaño"
              placeholder="Todos los tamaños"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productSizeID"
              item-title="productSizeName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductSizeIDSelected" 
                  @update:model-value="input.productSizeID = input.allProductSizeIDSelected ? display.productSize.map(productSize => productSize.productSizeID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productSizeID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productSizeID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productSizeID = input.productSizeID.filter(productSizeID => productSizeID != item.value); input.allProductSizeIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productSizeID.length - 3 }} {{ input.productSizeID.length - 3 == 1 ? 'tamaño de producto' : 'tamaños de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El nivel de nicotina del producto. Si se coloca al menos una nivel de nicotina de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los niveles de nicotina de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los niveles de nicotina de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productProviderID"
              v-model="input.productProviderID"
              :items="display.productProvider"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductProviderIDSelected = input.productProviderID.length == display.productProvider.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-briefcase"
              label="Filtrar por proveedor"
              placeholder="Todos los proveedores"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productProviderID"
              item-title="productProviderName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductProviderIDSelected" 
                  @update:model-value="input.productProviderID = input.allProductProviderIDSelected ? display.productProvider.map(productProvider => productProvider.productProviderID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productProviderID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productProviderID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productProviderID = input.productProviderID.filter(productProviderID => productProviderID != item.value); input.allProductProviderIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productProviderID.length - 3 }} {{ input.productProviderID.length - 3 == 1 ? 'proveedor de producto' : 'proveedores de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El proveedor del producto. Si se coloca al menos una proveedor de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los proveedores de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los proveedores de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productTagID"
              v-model="input.productTagID"
              :items="display.productTag"
              @keydown.enter.prevent="selectCRMWhatsappContactFromCRMWhatsappContactsView()"
              @update:model-value="input.allProductTagIDSelected = input.productTagID.length == display.productTag.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
              prepend-inner-icon="mdi-tag"
              label="Filtrar por tag"
              placeholder="Todos los tags"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productTagID"
              item-title="productTagName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductTagIDSelected" 
                  @update:model-value="input.productTagID = input.allProductTagIDSelected ? display.productTag.map(productTag => productTag.productTagID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productTagID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productTagID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productTagID = input.productTagID.filter(productTagID => productTagID != item.value); input.allProductTagIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productTagID.length - 3 }} {{ input.productTagID.length - 3 == 1 ? 'tag de producto' : 'tags de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El tag del producto. Si se coloca al menos una tag de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los tags de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los tags de producto disponibles</span>
        </v-tooltip>
      </div>
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 120px; padding: 15px; overflow: hidden; align-items: center; justify-content: center;">
        <v-btn 
          @click="selectCRMWhatsappContactFromCRMWhatsappContactsView(true)"
          :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView" 
          block
          color="indigo"
          class="hoverableText"
        >
        <v-icon size="large" style="margin-right: 10px;">mdi-magnify</v-icon>
        <h3>BUSCAR</h3>
        </v-btn>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="1000" location="top">
          <template v-slot:activator="{ props }">
            <v-btn 
              v-bind="props" 
              @click="setDefaultValues()"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMWhatsappContactFromCRMWhatsappContactsView" 
              block
              color="secondary"
              style="margin-top: 15px;"
              class="hoverableText"
            >
              <v-icon size="large" style="margin-right: 10px;">mdi-backspace</v-icon>
              <h3>LIMPIAR</h3>
            </v-btn>
          </template>
          <span style="width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
        </v-tooltip>
      </v-card>
    </v-card>
    <div class="contentContainer">
      <template v-if="loader.selectCRMWhatsappContactFromCRMWhatsappContactsView">
        <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 55px"></v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
        <div style="flex: 1;">
          <AppLoaderScreen
            :key="Math.random() * 1000000"
            :appLogoSize="'x-small'"
            :loadingText="'Cargando lista de contactos'"
            :dotsToAnimate="3"
            :hints="$assets.default.hints.CRMWhatsappContactsView"
            style="width: 100%; height: 100%;"
          ></AppLoaderScreen>
        </div>
      </template>
      <template v-else>
        <template v-if="display.CRMWhatsappContact.length > 0">
          <v-data-table
            ref="CRMWhatsappContactTable"
            :headers="computed_sortedCRMWhatsappContactHeaders" 
            :items="display.CRMWhatsappContact" 
            :loading="loader.selectCRMWhatsappContactFromCRMWhatsappContactsView"
            :items-per-page="-1"
            fixed-header
            hover
            style="flex: 1; overflow-y: auto; scrollbar-width: thin;"
          >
            <template v-slot:headers="{ columns }">
              <tr>
                <th v-for="column in columns" :key="column.key">
                  <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 25px;">
                    <v-icon v-if="navigation.searchVisible == false && display.CRMWhatsappContactHeaders.find(header => header.value == column.key).index == 0" @click="navigation.searchVisible = true" size="large" style="margin-right: 10px;">mdi-arrow-right-bottom-bold</v-icon>
                    <v-icon v-if="display.CRMWhatsappContactHeaders.find(header => header.value == column.key).index > 0" @click="updateTableHeaderIndex(column.key, -1)" color="secondary" size="x-small" class="hoverableElement" style="margin-right: 10px">mdi-arrow-left-bold</v-icon>
                    <v-icon color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappContactHeaders.find(header => header.value == column.key).icon }}</v-icon>
                    <span v-if="display.CRMWhatsappContactHeaders.find(header => header.value == column.key).visible" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappContactHeaders.find(header => header.value == column.key).title }}</strong></span>
                    <v-icon @click="display.CRMWhatsappContactHeaders.find(header => header.value == column.key).visible = !display.CRMWhatsappContactHeaders.find(header => header.value == column.key).visible; updateTableVisibility()" color="secondary" size="x-small" class="hoverableElement">mdi-{{ display.CRMWhatsappContactHeaders.find(header => header.value == column.key).visible ? 'eye' : 'eye-off' }}</v-icon>
                    <v-icon v-if="display.CRMWhatsappContactHeaders.find(header => header.value == column.key).index < display.CRMWhatsappContactHeaders.length - 1" @click="updateTableHeaderIndex(column.key, 1)" color="secondary" size="x-small" class="hoverableElement" style="margin-left: 10px">mdi-arrow-right-bold</v-icon>
                  </v-card>
                  <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
                </th>
              </tr>
            </template>
            <template v-slot:item="row">
              <tr 
                :class="navigation.CRMWhatsappContactContextMenuItem?.CRMWhatsappContactID == row.item.CRMWhatsappContactID ? 'selectedVDataTableRow' : (loader.selectCRMWhatsappContactFromCRMWhatsappContactsViewPagination ? 'loadingVDataTableRow' : null)" 
                :style="loader.selectCRMWhatsappContactFromCRMWhatsappContactsViewPagination ? 'pointer-events: none;' : null"
              >
                <template v-for="header in computed_sortedCRMWhatsappContactHeaders" :key="header.value">
                  <td @contextmenu.prevent="navigation.CRMWhatsappContactContextMenuIsVisible = true; navigation.CRMWhatsappContactContextMenuItem = row.item; navigation.CRMWhatsappContactContextMenuX = $event.clientX; navigation.CRMWhatsappContactContextMenuY = $event.clientY;">
                    <template v-if="header.value == 'CRMWhatsappContactID' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-hover>
                        <template v-slot="{ isHovering, props: hoverProps }">
                          <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                              <template v-slot:activator="{ props: tooltipProps }">
                                <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, `ID del contacto`, 'o', row.item.CRMWhatsappContactID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappContactID }}</strong></p>
                              </template>
                            </v-tooltip>
                          </template>
                          <template v-else>
                            <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, `ID del contacto`, 'o', row.item.CRMWhatsappContactID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappContactID }}</strong></p>
                          </template>
                        </template>
                      </v-hover>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactName' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <p style="white-space: nowrap;">{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactPhoneNumber' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <p style="white-space: nowrap;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactCRMLocalityID' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <template v-if="row.item.CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID)">
                        <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                          <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                        </v-chip>
                      </template>
                      <template v-else>
                        <v-chip color="primary" variant="flat" elevation="2" label>
                          <p>No registrada</p>
                        </v-chip>
                      </template>
                    </template>


                    <template v-else-if="header.value == 'CRMWhatsappConversationAction' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-btn 
                        @click="$root.dialogComponent.openSendCRMWhatsappMessageToCRMWhatsappContactDialog(row.item.CRMWhatsappContactID, false)"  
                        color="primary" 
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-chat-plus</v-icon>
                        <p style="font-size: small;">CONVERSACIÓN</p>
                      </v-btn>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationHistoryAction' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-btn 
                        @click="$root.dialogComponent.openCRMWhatsappConversationHistoryDialog(row.item.CRMWhatsappContactID)"
                        color="primary" 
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-history</v-icon>
                        <p style="font-size: small;">HISTORIAL</p>
                      </v-btn>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactLocationAction' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-btn 
                        @click="$root.dialogComponent.openCRMWhatsappContactLocationDialog(row.item.CRMWhatsappContactID)"
                        color="primary" 
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-map-marker</v-icon>
                        <p style="font-size: small;">UBICACIONES</p>
                      </v-btn>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactFollowupAction' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-btn 
                        @click="$root.dialogComponent.openCRMWhatsappProductFollowupHistoryDialog(row.item.CRMWhatsappContactID, null)"
                        color="primary" 
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-source-branch-sync</v-icon>
                        <p style="font-size: small;">SEGUIMIENTOS</p>
                      </v-btn>
                    </template>


                    <template v-else-if="header.value == 'CRMWhatsappContactUpdateAction' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-btn 
                        @click="$root.dialogComponent.openCRMWhatsappContactDialog(row.item.CRMWhatsappContactID, 'update')"
                        color="warning" 
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-pencil</v-icon>
                        <p style="font-size: small;">ACTUALIZAR</p>
                      </v-btn>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactDeleteAction' && display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == header.value).visible">
                      <v-btn 
                        @click="$root.dialogComponent.openCRMWhatsappContactDialog(row.item.CRMWhatsappContactID, 'delete')"
                        color="error" 
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-delete</v-icon>
                        <p style="font-size: small;">ELIMINAR</p>
                      </v-btn>
                    </template>
                  </td>
                </template>
                
              </tr>
            </template>
            <template v-slot:bottom></template>
          </v-data-table>
        </template>
        <template v-else>
          <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 55px"></v-card>
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
          <div style="flex: 1;">
            <template v-if="navigation.noData">
              <div 
                @click="setDefaultValues()"
                style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px;"
              >
                <div class="hoverableText">
                  <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
                  <p style="color: #9e9e9e;">No se encontraron contactos con los filtros seleccionados</p>
                  <p style="color: #9e9e9e;">Haz click <span style="color: #3F51B5; text-decoration: underline;">aquí</span> para limpiar los filtros de búsqueda</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px;">
                <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
                <div style="display: flex; align-items: center; gap: 10px;">
                  <p style="color: #9e9e9e;">Selecciona uno o más criterios de búsqueda y presiona</p>
                  <v-btn color="indigo" readonly>
                    <v-icon size="large" style="margin-right: 10px;">mdi-magnify</v-icon>
                    <h3>BUSCAR</h3>
                  </v-btn>
                </div>
              </div>
            </template>
          </div>
        </template>
      </template>
      <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
      <v-card elevation="0" rounded="0" color="primary" class="bottomContainer" style="padding: 10px; height: 60px; display: flex; justify-content: center; align-items: center;">
        <div v-if="display.CRMWhatsappContact.length > 0" class="paginator">
          <v-pagination
            v-model="navigation.page"
            @update:model-value="display.CRMWhatsappContact.length > 0 ? selectCRMWhatsappContactFromCRMWhatsappContactsView(false) : null"
            :length="Math.ceil(display.CRMWhatsappContactCount / navigation.limit)"
            :total-visible="5"
            density="compact"
            size="small"
            :disabled="loader.selectCRMWhatsappContactFromCRMWhatsappContactsViewPagination"
          ></v-pagination>
          <p style="font-size: x-small;">{{ (display.CRMWhatsappContactCount == 0) ? `0 de 0 contactos` : `${(navigation.page - 1) * navigation.limit + 1} - ${Math.min(navigation.page * navigation.limit, display.CRMWhatsappContactCount)} de ${display.CRMWhatsappContactCount} ${display.CRMWhatsappContactCount > 1 ? 'contactos' : 'contacto'}`}}</p>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
  .v-data-table th {
    padding: 0 !important;
  }

  .mainContainer {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin-top: 0;
    padding-top: 0;
  }
  .navigationContainer {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  .navigationSearchContainer {
    flex: 1;
    width: 100%;
    padding: 15px;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .paginator {
    margin-left: auto; 
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center;
  }

  @media (max-width: 1200px) {
    .hideSearchContainer {
      display: none;
    }
    .mainContainer {
      flex-direction: column;
      height: auto;
      overflow-y: auto;
    }
    .navigationContainer {
      width: 100%;
    }
    .contentContainer {
      min-height: 900px;
      max-height: 900px;
    }
    .hideSummaryTable {
      min-height: 50px;
      max-height: 50px;
      align-items: center;
      justify-content: center;
    }
    .bottomContainer {
      min-height: 80px;
      max-height: 80px;
      align-items: center;
      justify-content: center;
    }
    .paginator {
      margin-left: 0;
      justify-content: center;
      align-items: center;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import LZString from 'lz-string';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: 
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactID: null,
        CRMWhatsappContactIDSearchAutocomplete: null,
        CRMWhatsappContactIDSearch: null,
        CRMLocalityID: [],
        allCRMLocalityIDSelected: false,
        CRMWhatsappContactNote: null,
        CRMWhatsappConversationID: null,
        lastCRMWhatsappConversationTime: null,
        CRMWhatsappConversationNote: null,
        CRMWhatsappMessageContent: null,
        CRMWhatsappInvoiceID: null,
        lastCRMWhatsappInvoiceTime: null,
        CRMLocalityMapDivisionID: [],
        allCRMLocalityMapDivisionIDSelected: false,
        productIDSearch: null,
        productID: null,
        productCategoryID: [],
        allProductCategoryIDSelected: false,
        productBrandID: [],
        allProductBrandIDSelected: false,
        productModelID: [],
        allProductModelIDSelected: false,
        productFlavorID: [],
        allProductFlavorIDSelected: false,
        productNicotineLevelID: [],
        allProductNicotineLevelIDSelected: false,
        productSizeID: [],
        allProductSizeIDSelected: false,
        productProviderID: [],
        allProductProviderIDSelected: false,
        productTagID: [],
        allProductTagIDSelected: false
      },
      display: 
      {
        CRMWhatsappContactOptions: [],
        lastCRMWhatsappConversationTimeOptions: 
        [
          {title: '1 día', value: 1},
          {title: '3 días', value: 3},
          {title: '1 semana', value: 7},
          {title: '2 semanas', value: 14},
          {title: '1 mes', value: 30},
          {title: '2 meses', value: 60},
          {title: '3 meses', value: 90},
          {title: '6 meses', value: 180},
          {title: '1 año', value: 365}
        ],
        lastCRMWhatsappInvoiceTimeOptions: 
        [
          {title: '1 día', value: 1},
          {title: '3 días', value: 3},
          {title: '1 semana', value: 7},
          {title: '2 semanas', value: 14},
          {title: '1 mes', value: 30},
          {title: '2 meses', value: 60},
          {title: '3 meses', value: 90},
          {title: '6 meses', value: 180},
          {title: '1 año', value: 365}
        ],
        CRMWhatsappContactHeaders: [],
        product: [],
        productCategory: [],
        productBrand: [],
        productModel: [],
        productFlavor: [],
        productNicotineLevel: [],
        productSize: [],
        productProvider: [],
        productTag: [],
        CRMWhatsappContact: [],
        CRMWhatsappContactCount: 0
      },
      navigation: 
      {
        searchVisible: true,
        page: 1,
        limit: 50,
        noData: false,
        CRMWhatsappContactContextMenuIsVisible: false,
        CRMWhatsappContactContextMenuItem: null,
        CRMWhatsappContactContextMenuX: 0,
        CRMWhatsappContactContextMenuY: 0
      },
      loader: 
      {
        getSystemInformationData: false,
        selectCRMWhatsappContactFromCRMWhatsappContactsView: false,
        selectCRMWhatsappContactFromCRMWhatsappContactsViewPagination: false
      },
      interval: 
      {      
        autocompleteCRMWhatsappContactInterval: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_CRMLocalityMapDivision(){
        if (this.input.CRMLocalityID.length == 0) return this.display.CRMLocalityMapDivision;
        return this.display.CRMLocalityMapDivision.slice().filter(CRMLocalityMapDivision => this.input.CRMLocalityID.includes(CRMLocalityMapDivision.CRMLocalityID));
      },
      computed_sortedCRMWhatsappContactHeaders(){
        return this.display.CRMWhatsappContactHeaders.slice().sort((CRMWhatsappContactHeaderA, CRMWhatsappContactHeaderB) => CRMWhatsappContactHeaderA.index - CRMWhatsappContactHeaderB.index);
      }
    },

    methods:
    {
      async selectCRMWhatsappContactFromCRMWhatsappContactsView(newSearch){
        if (newSearch){
          this.display.CRMWhatsappContactCount = 0;
          this.display.CRMWhatsappContact.length = 0;
          this.navigation.page = 1;
          this.navigation.noData = false;
          this.loader.selectCRMWhatsappContactFromCRMWhatsappContactsView = true;
        }
        this.loader.selectCRMWhatsappContactFromCRMWhatsappContactsViewPagination = true;
        const selectCRMWhatsappContactFromCRMWhatsappContactsViewRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID,
          'CRMWhatsappContactIDSearch': this.input.CRMWhatsappContactIDSearch,
          'CRMLocalityID': this.input.CRMLocalityID,
          'CRMWhatsappContactNote': this.input.CRMWhatsappContactNote,
          'CRMWhatsappConversationID': this.input.CRMWhatsappConversationID,
          'lastCRMWhatsappConversationTime': this.input.lastCRMWhatsappConversationTime,
          'CRMWhatsappConversationNote': this.input.CRMWhatsappConversationNote,
          'CRMWhatsappMessageContent': this.input.CRMWhatsappMessageContent,
          'CRMWhatsappInvoiceID': this.input.CRMWhatsappInvoiceID,
          'lastCRMWhatsappInvoiceTime': this.input.lastCRMWhatsappInvoiceTime,
          'CRMLocalityMapDivisionID': this.input.CRMLocalityMapDivisionID,
          'productID': this.input.productID,
          'productCategoryID': this.input.productCategoryID,
          'productBrandID': this.input.productBrandID,
          'productModelID': this.input.productModelID,
          'productFlavorID': this.input.productFlavorID,
          'productNicotineLevelID': this.input.productNicotineLevelID,
          'productSizeID': this.input.productSizeID,
          'productProviderID': this.input.productProviderID,
          'productTagID': this.input.productTagID,
          'page': this.navigation.page,
          'limit': this.navigation.limit
        };
        const selectCRMWhatsappContactFromCRMWhatsappContactsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/selectCRMWhatsappContactFromCRMWhatsappContactsView', selectCRMWhatsappContactFromCRMWhatsappContactsViewRequestQuery);
        if (selectCRMWhatsappContactFromCRMWhatsappContactsViewResult.success){
          this.display.CRMWhatsappContactCount = selectCRMWhatsappContactFromCRMWhatsappContactsViewResult.result.CRMWhatsappContactCount;
          this.display.CRMWhatsappContact = selectCRMWhatsappContactFromCRMWhatsappContactsViewResult.result.CRMWhatsappContact;
          this.navigation.noData = this.display.CRMWhatsappContactCount == 0;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactFromCRMWhatsappContactsView_error', 'error', 'Ha ocurrido un error inesperado al consultar la lista de contactos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.selectCRMWhatsappContactFromCRMWhatsappContactsView = false;
        this.loader.selectCRMWhatsappContactFromCRMWhatsappContactsViewPagination = false;
      },

      autocompleteCRMWhatsappContact(){
        if (this.interval.autocompleteCRMWhatsappContactInterval) {
          clearTimeout(this.interval.autocompleteCRMWhatsappContactInterval);
          this.interval.autocompleteCRMWhatsappContactInterval = null;
        }
        if (this.input.CRMWhatsappContactIDSearchAutocomplete && /\S/.test(this.input.CRMWhatsappContactIDSearchAutocomplete)){
          this.interval.autocompleteCRMWhatsappContactInterval = setTimeout(async () => {
            this.loader.autocompleteCRMWhatsappContact = true;
            if (!this.input.CRMWhatsappContactIDSearchAutocomplete) {
              this.display.CRMWhatsappContactOptions.length = 0;
              this.loader.autocompleteCRMWhatsappContact = false;
              this.$generalFunctions.default.blurInput(this, 'CRMWhatsappContactIDSearch');
              return;
            }
            const autocompleteCRMWhatsappContactRequestQuery =
            {
              'localStorage': 
              {
                'CRMAccountID': this.systemInformationData.CRMAccountID
              },
              'CRMWhatsappContactSearch': this.input.CRMWhatsappContactIDSearchAutocomplete
            };
            const autocompleteCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/autocompleteCRMWhatsappContact', autocompleteCRMWhatsappContactRequestQuery);
            if (autocompleteCRMWhatsappContactResult.success) {
              this.display.CRMWhatsappContactOptions = autocompleteCRMWhatsappContactResult.result;
              if (this.display.CRMWhatsappContactOptions.length == 0) this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_noResults', 'info', 'No se ha encontrado ningún contacto con el nombre buscado', null, false);
              else {
                this.display.CRMWhatsappContactOptions.forEach(CRMWhatsappContact => {
                  CRMWhatsappContact.CRMWhatsappContactAutocomplete = `${CRMWhatsappContact.CRMWhatsappContactName} - ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappContact.CRMWhatsappContactPhoneNumber, false)}`;
                });
              }
            } else {
              this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al consultar los contactos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
            }
            this.loader.autocompleteCRMWhatsappContact = false;          
          }, 1000);
        }
      },

      async selectProductSearchParameters(){
        this.loader.selectProductSearchParameters = true;
        const selectProductSearchParametersRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectProductSearchParametersResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/product/functions/selectProductSearchParameters', selectProductSearchParametersRequestQuery);
        if (selectProductSearchParametersResult.success) {
          this.display.product = selectProductSearchParametersResult.result.products.map(product => ({
            'productID': product.productID,
            'productName': product.productName,
            'productAutocomplete': `${product.productID} - ${product.productName}`
          }));
          this.display.productCategory = selectProductSearchParametersResult.result.productCategories;
          this.display.productBrand = selectProductSearchParametersResult.result.productBrands;
          this.display.productModel = selectProductSearchParametersResult.result.productModels;
          this.display.productFlavor = selectProductSearchParametersResult.result.productFlavors;
          this.display.productNicotineLevel = selectProductSearchParametersResult.result.productNicotineLevels;
          this.display.productSize = selectProductSearchParametersResult.result.productSizes;
          this.display.productProvider = selectProductSearchParametersResult.result.productProviders;
          this.display.productTag = selectProductSearchParametersResult.result.productTags;
          this.loader.selectProductSearchParameters = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectProductSearchParameters_error', 'error', 'Ha ocurrido un error inesperado al consultar los parámetros de búsqueda de productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      
      scanProduct(){
        const scannedProduct = this.display.product.find(product => product.productID == this.input.productIDSearch);
        if (scannedProduct){
          this.input.productID = scannedProduct.productID;
          this.input.productIDSearch = scannedProduct.productName;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('scanProduct_error', 'error', 'No se ha encontrado ningún producto con el código de barras escaneado', null, false);
        }
      },

      copyCRMWhatsappContactToClipboard(){
        let copyCRMWhatsappContactToClipboard =
        [
          `CONTACTO ${this.navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactID}\n\n`,
          this.display.CRMWhatsappContactHeaders.find(CRMWhatsappContactHeader => CRMWhatsappContactHeader.value == 'CRMWhatsappContactName').visible ? `Nombre del contacto: ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.navigation.CRMWhatsappContactContextMenuItem)}\n` : '',
          this.display.CRMWhatsappContactHeaders.find(CRMWhatsappContactHeader => CRMWhatsappContactHeader.value == 'CRMWhatsappContactPhoneNumber').visible ? `Teléfono del contacto: ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(this.navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactPhoneNumber, false)}\n` : '',
          this.display.CRMWhatsappContactHeaders.find(CRMWhatsappContactHeader => CRMWhatsappContactHeader.value == 'CRMWhatsappContactCRMLocalityID').visible ? `Localidad del contacto: ${this.systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == this.navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactCRMLocalityID) ? this.systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == this.navigation.CRMWhatsappContactContextMenuItem.CRMWhatsappContactCRMLocalityID).CRMLocalityName : 'No registrado'}\n` : '',
        ].join('');
        this.$generalFunctions.default.copyToClipboardWithoutTitle(this, 'Resumen del contacto', 'a', copyCRMWhatsappContactToClipboard);
      },
      
      updateURLSearchQuery(){
        let searchQuery = 
        {
          '1': this.input.CRMWhatsappContactID,
          '2': this.input.CRMWhatsappContactIDSearch,
          '3': this.input.CRMWhatsappContactIDSearch && this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactIDSearch) ? [this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactIDSearch).CRMWhatsappContactName, this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactIDSearch).CRMWhatsappContactPhoneNumber, this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactIDSearch).CRMWhatsappContactAutocomplete] : null,
          '4': this.input.CRMLocalityID,
          '5': this.input.CRMWhatsappContactNote,
          '6': this.input.CRMWhatsappConversationID,
          '7': this.input.lastCRMWhatsappConversationTime,
          '8': this.input.CRMWhatsappConversationNote,
          '9': this.input.CRMWhatsappMessageContent,
          '10': this.input.CRMWhatsappInvoiceID,
          '11': this.input.lastCRMWhatsappInvoiceTime,
          '12': this.input.CRMLocalityMapDivisionID,
          '13': this.input.productID,
          '14': this.input.productCategoryID,
          '15': this.input.productBrandID,
          '16': this.input.productModelID,
          '17': this.input.productFlavorID,
          '18': this.input.productNicotineLevelID,
          '19': this.input.productSizeID,
          '20': this.input.productProviderID,
          '21': this.input.productTagID
        };
        searchQuery = Object.fromEntries(Object.entries(searchQuery).filter(([ , v]) => v != null && v != undefined));
        const searchQueryCompressed = LZString.compressToEncodedURIComponent(JSON.stringify(searchQuery));
        this.$router.replace({query: {searchQuery: searchQueryCompressed}});
      },

      async decodeURLSearchQuery(){
        let searchQuery = this.$route.query.searchQuery;
        if (searchQuery){
          searchQuery = JSON.parse(LZString.decompressFromEncodedURIComponent(searchQuery));
          this.input.CRMWhatsappContactID = searchQuery['1'];
          this.input.CRMWhatsappContactIDSearch = searchQuery['2'];
          this.display.CRMWhatsappContactOptions = searchQuery['2'] && searchQuery['3'] ? [{'CRMWhatsappContactID': searchQuery['2'], 'CRMWhatsappContactName': searchQuery['3'][0], 'CRMWhatsappContactPhoneNumber': searchQuery['3'][1], 'CRMWhatsappContactAutocomplete': searchQuery['3'][2]}] : [];
          this.input.CRMLocalityID = searchQuery['4'] || [];
          this.input.allCRMLocalityIDSelected = this.input.CRMLocalityID.length == this.systemInformationData.CRMLocalities.length;
          this.input.CRMWhatsappContactNote = searchQuery['5'];
          this.input.CRMWhatsappConversationID = searchQuery['6'];
          this.input.lastCRMWhatsappConversationTime = searchQuery['7'];
          this.input.CRMWhatsappConversationNote = searchQuery['8'];
          this.input.CRMWhatsappMessageContent = searchQuery['9'];
          this.input.CRMWhatsappInvoiceID = searchQuery['10'];
          this.input.lastCRMWhatsappInvoiceTime = searchQuery['11'];
          this.input.CRMLocalityMapDivisionID = searchQuery['12'] || [];
          this.input.allCRMLocalityMapDivisionIDSelected = this.input.CRMLocalityMapDivisionID.length == this.systemInformationData.CRMLocalities.flatMap(CRMLocality => CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions).filter(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID != null).length;
          this.input.productID = searchQuery['13'];
          this.input.productCategoryID = searchQuery['14'] || [];
          this.input.allProductCategoryIDSelected = this.input.productCategoryID.length == this.display.productCategory.length;
          this.input.productBrandID = searchQuery['15'] || [];
          this.input.allProductBrandIDSelected = this.input.productBrandID.length == this.display.productBrand.length;
          this.input.productModelID = searchQuery['16'] || [];
          this.input.allProductModelIDSelected = this.input.productModelID.length == this.display.productModel.length;
          this.input.productFlavorID = searchQuery['17'] || [];
          this.input.allProductFlavorIDSelected = this.input.productFlavorID.length == this.display.productFlavor.length;
          this.input.productNicotineLevelID = searchQuery['18'] || [];
          this.input.allProductNicotineLevelIDSelected = this.input.productNicotineLevelID.length == this.display.productNicotineLevel.length;
          this.input.productSizeID = searchQuery['19'] || [];
          this.input.allProductSizeIDSelected = this.input.productSizeID.length == this.display.productSize.length;
          this.input.productProviderID = searchQuery['20'] || [];
          this.input.allProductProviderIDSelected = this.input.productProviderID.length == this.display.productProvider.length;
          this.input.productTagID = searchQuery['21'] || [];
          this.input.allProductTagIDSelected = this.input.productTagID.length == this.display.productTag.length;
        }
      },

      updateTableHeaderIndex(headerValue, indexChange) {
        const updatedTableHeader = this.display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == headerValue);
        const swappedTableHeader = this.display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.index == (this.display.CRMWhatsappContactHeaders.find(displayCRMWhatsappContactHeader => displayCRMWhatsappContactHeader.value == headerValue).index + indexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        localStorage.setItem('CRMWhatsappContactsView_CRMWhatsappContactHeaders', JSON.stringify(this.display.CRMWhatsappContactHeaders));      
      },
      
      updateTableVisibility(){
        localStorage.setItem('CRMWhatsappContactsView_CRMWhatsappContactHeaders', JSON.stringify(this.display.CRMWhatsappContactHeaders));      
      },

      async prepareTable() {
        const CRMWhatsappContactHeaders = 
        [
          {title: 'ID', value: 'CRMWhatsappContactID', sortable: false, icon: 'mdi-barcode', visible: true, index: 0},
          {title: 'NOMBRE', value: 'CRMWhatsappContactName', sortable: false, icon: 'mdi-account', visible: true, index: 1},
          {title: 'TELÉFONO', value: 'CRMWhatsappContactPhoneNumber', sortable: false, icon: 'mdi-phone', visible: true, index: 2},
          {title: 'LOCALIDAD', value: 'CRMWhatsappContactCRMLocalityID', sortable: false, icon: 'mdi-store', visible: true, index: 3},
          {title: 'CONVERSACIÓN', value: 'CRMWhatsappConversationAction', sortable: false, icon: 'mdi-chat-plus', visible: true, index: 3},
          {title: 'HISTORIAL', value: 'CRMWhatsappConversationHistoryAction', sortable: false, icon: 'mdi-history', visible: true, index: 4},
          {title: 'UBICACIONES', value: 'CRMWhatsappContactLocationAction', sortable: false, icon: 'mdi-map-marker', visible: true, index: 5},
          {title: 'SEGUIMIENTOS', value: 'CRMWhatsappContactFollowupAction', sortable: false, icon: 'mdi-source-branch-sync', visible: true, index: 6},
          {title: 'ACTUALIZAR', value: 'CRMWhatsappContactUpdateAction', sortable: false, icon: 'mdi-pencil', visible: true, index: 7},
          ...(this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappContacts/deleteCRMWhatsappContact')?.CRMAgentPermissionValue == '1' ? [{title: 'ELIMINAR', value: 'CRMWhatsappContactDeleteAction', sortable: false, icon: 'mdi-delete', visible: true, index: 8}] : [])
        ];
        const localStorageCRMWhatsappContactHeaders = JSON.parse(localStorage.getItem('CRMWhatsappContactsView_CRMWhatsappContactHeaders') || JSON.stringify(CRMWhatsappContactHeaders));
        for (const localStorageCRMWhatsappContactHeader of localStorageCRMWhatsappContactHeaders){
          const CRMWhatsappContactHeader = CRMWhatsappContactHeaders.find(CRMWhatsappContactHeader => CRMWhatsappContactHeader.value == localStorageCRMWhatsappContactHeader.value);
          if (CRMWhatsappContactHeader){
            if (localStorageCRMWhatsappContactHeader.visible != null) CRMWhatsappContactHeader.visible = localStorageCRMWhatsappContactHeader.visible;
            if (localStorageCRMWhatsappContactHeader.index != null) CRMWhatsappContactHeader.index = localStorageCRMWhatsappContactHeader.index;
          }
        }
        this.display.CRMWhatsappContactHeaders = CRMWhatsappContactHeaders.sort((CRMWhatsappContactHeaderA, CRMWhatsappContactHeaderB) => CRMWhatsappContactHeaderA.index - CRMWhatsappContactHeaderB.index);
      },

      setDefaultValues(){
        this.input.CRMWhatsappContactID = null;
        this.input.CRMWhatsappContactIDSearchAutocomplete = null;
        this.input.CRMWhatsappContactIDSearch = null;
        this.input.CRMLocalityID.length = 0;
        this.input.allCRMLocalityIDSelected = false;
        this.input.CRMWhatsappContactNote = null;
        this.input.CRMWhatsappConversationID = null;
        this.input.lastCRMWhatsappConversationTime = null;
        this.input.CRMWhatsappConversationNote = null;
        this.input.CRMWhatsappMessageContent = null;
        this.input.CRMWhatsappInvoiceID = null;
        this.input.lastCRMWhatsappInvoiceTime = null;
        this.input.CRMLocalityMapDivisionID.length = 0;
        this.input.allCRMLocalityMapDivisionIDSelected = false;
        this.input.productIDSearch = null;
        this.input.productID = null;
        this.input.productCategoryID.length = 0;
        this.input.allProductCategoryIDSelected = false;
        this.input.productBrandID.length = 0;
        this.input.allProductBrandIDSelected = false;
        this.input.productModelID.length = 0;
        this.input.allProductModelIDSelected = false;
        this.input.productFlavorID.length = 0;
        this.input.allProductFlavorIDSelected = false;
        this.input.productNicotineLevelID.length = 0;
        this.input.allProductNicotineLevelIDSelected = false;
        this.input.productSizeID.length = 0;
        this.input.allProductSizeIDSelected = false;
        this.input.productProviderID.length = 0;
        this.input.allProductProviderIDSelected = false;
        this.input.productTagID.length = 0;
        this.input.allProductTagIDSelected = false;
        this.display.CRMWhatsappContactCount = 0;
        this.display.CRMWhatsappContact.length = 0;
        this.navigation.page = 1;
        this.navigation.noData = false;
        this.updateURLSearchQuery();
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactID');
      },
      
      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.display.CRMLocalityMapDivision = this.systemInformationData.CRMLocalities.flatMap(CRMLocality => 
              CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => ({
                'CRMLocalityID': CRMLocality.CRMLocalityID,
                'CRMLocalityMapDivisionID': CRMLocalityMapDivision.CRMLocalityMapDivisionID,
                'CRMLocalityMapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName,
              }))
            );
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.getSystemInformationData = false;
      }
    },

    async mounted(){
      await this.getSystemInformationData();
      await this.selectProductSearchParameters();
      await this.prepareTable();
      await this.decodeURLSearchQuery();
      this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactID');
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
      if (this.interval.autocompleteCRMWhatsappContactInterval) clearTimeout(this.interval.autocompleteCRMWhatsappContactInterval);
      this.interval.autocompleteCRMWhatsappContactInterval = null;
    }
  }
</script>